import * as Papa from 'papaparse';
import { CustomerMapParsed, FieldMapping } from '../interfaces';
import { Tool } from './base';

export class SplunkTool extends Tool {
  public readonly toolName = 'Splunk';

  // Temporary until a better global default for Splunk can be built
  private defaultFieldMapping: FieldMapping = {
    name: 'foo',
    category: 'foo',
    fields: [],
    toolSpecific: [{ index: '*' }, { sourceType: '*' }],
  };

  /**
   * Extended to prefix content with index + sourcetype from the fieldMapping
   */
  public renderContentTemplatefromFieldMapping(
    contentTemplate: string,
    fieldMapping?: FieldMapping,
  ): string {
    fieldMapping = fieldMapping ?? this.defaultFieldMapping;

    const generatedContent = super.renderContentTemplatefromFieldMapping(
      contentTemplate,
      fieldMapping,
    );

    return `index=${
      Object.values(fieldMapping.toolSpecific[0])[0]
        ? Object.values(fieldMapping.toolSpecific[0])[0]
        : '*'
    } sourcetype=${
      Object.values(fieldMapping.toolSpecific[1])[0]
        ? Object.values(fieldMapping.toolSpecific[1])[0]
        : '*'
    } ${generatedContent}`;
  }

  /**
   * Parse CSV export contents into known format
   * @param fileContents Splunk export CSV
   */
  public parseMapUpload(fileContents: string): CustomerMapParsed {
    const csvParsed = Papa.parse<string[]>(fileContents, {
      skipEmptyLines: true,
    }).data;

    // remove header line
    csvParsed.shift();

    return csvParsed.map((row) => {
      return {
        index: row[0],
        sourcetype: row[1],
        fields: row[2].split(', '),
      };
    });
  }

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string,
  ): string {
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    return `${rootURL}en-US/app/launcher/search?q=${encodedRenderedContent}`;
  }
}
